module.exports = __webpack_public_path__ + "img/Google__G__Logo.45aebcf8.svg";